import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Joyride from "react-joyride";

export const sidebarSteps = [
  {
    target: "#explore-agents-btn",
    content: "Click here to explore available AI agents.",
    placement: "right",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: "#all-agents-btn",
    content: "Click here to see all available AI agents.",
    placement: "right",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: "#personalize-assistant-btn",
    content: "Click here to personalize your AI assistant.",
    placement: "top",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: "#chat-now-btn",
    content: "Click here to start chatting with the selected AI assistant.",
    placement: "top",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: "#featured-agents-btn",
    content: "These are the top-rated featured AI agents.",
    placement: "right",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: "#favorite-agents-btn",
    content: "View your favorite AI agents here.",
    placement: "right",
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: "#team-agents-btn",
    content: "Here you can find your Team Agents and collaborate with them.",
    placement: "right",
    disableBeacon: true,
    disableScrolling: true,
    spotlightClicks: false,
    styles: {
      tooltip: {
        dataAttribute: "data-team-agents-tooltip",
      },
    },
}

];

const SidebarTour = () => {
  const [showTour, setShowTour] = useState(false);
  const [stepIndex, setStepIndex] = useState(0); // Track current step
  const location = useLocation(); // Detects route changes

  // useEffect(() => {
  //   if (location.pathname === "/public-agent") {
  //     setStepIndex(1); // Skip step 1 and start from step 2
  //   } else {
  //     setStepIndex(0); // Start normally from step 1
  //   }

  //   setTimeout(() => {
  //     setShowTour(true);
  //   }, 500);
  // }, [location.pathname]);

  return (
    <>
    </>
    // <Joyride
    //   steps={sidebarSteps}
    //   stepIndex={stepIndex} // Control steps manually
    //   run={showTour}
    //   continuous
    //   showProgress
    //   showSkipButton
    //   disableBeacon
    //   scrollToFirstStep={false} 
    //   spotlightPadding={0}
    //   styles={{
    //     options: {
    //       primaryColor: "#23418F",
    //     },
    //   }}
    //   floaterProps={{
    //     disableScrolling: true, // Ensures Joyride doesn't force scrolling
    //   }}
    //   callback={(data) => {
    //     const { action, status, index, type } = data;

    //     if (type === "step:after") {
    //       if (index === 0 && (action === "next" || action === "close")) {
    //         setTimeout(() => {
    //           document.getElementById("explore-agents-btn")?.click();
    //         }, 100);
    //       }

    //       // Move to next step when "Next" is clicked
    //       if (action === "next") {
    //         setStepIndex((prev) => prev + 1);
    //       }
    //     }
    //   }}
    // />
  );
};

export default SidebarTour;
